import { render, staticRenderFns } from "./ServiceWidget.vue?vue&type=template&id=142863b5&scoped=true&"
import script from "./ServiceWidget.vue?vue&type=script&lang=js&"
export * from "./ServiceWidget.vue?vue&type=script&lang=js&"
import style0 from "./ServiceWidget.vue?vue&type=style&index=0&id=142863b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142863b5",
  null
  
)

export default component.exports